/*
 * Copyright (c) 2023 by Felix Heim, felix-heim@web.de
 *
 * This product includes software developed at
 * The Apache Software Foundation (http://www.apache.org/).
 */

(function() {
    'use strict';

    angular
        .module('askApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('board.dinghy.newsletter', {
            parent: 'board.dinghy',
            url: '/newsletter',
            data: {
                authorities: ['ROLE_DINGHY', 'ROLE_BOARD'],
                pageTitle: 'askApp.dinghy.newsletter.title'
            },
            views: {
                'dinghy@board.dinghy': {
                    templateUrl: 'app/board/dinghy/newsletter/dinghy-newsletter.html',
                    controller: 'DinghyNewsletterController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('project');
                    $translatePartialLoader.addPart('dinghy');
                    $translatePartialLoader.addPart('member-management');
                    return $translate.refresh();
                }]
            }
        });
    }
})();
